
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqs0CKtWKp9RPWq01nqeA5n6nDsbhxkmyjWku68Md8MJqIMeta } from "/opt/buildhome/repo/pages/faqs.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as usersDdKPYX7w1ohR5mdXAQEOOek61BW6bWXppqUQM2l77ncMeta } from "/opt/buildhome/repo/pages/users.vue?macro=true";
import { default as eventsolhiYTdAs3OdxlS9A7weFHvOg_uQSmkgm67fKyTXpNoMeta } from "/opt/buildhome/repo/pages/events.vue?macro=true";
import { default as sign_inFFyEGpE7oqBl66UUOrU5KCGZKsGZ8fc1vpA5h_45LpX_kMeta } from "/opt/buildhome/repo/pages/sign_in.vue?macro=true";
import { default as postsuQnOllF0vg_45_45QXjWm_45xfUJlCQrIr6cQjS769EK9rwWgMeta } from "/opt/buildhome/repo/pages/blog/posts.vue?macro=true";
import { default as newo1IuT9FGWtVfRT1zp4vJwDkiQcG_457F7qQtnV7EF4AEUMeta } from "/opt/buildhome/repo/pages/blog/post/new.vue?macro=true";
import { default as categoriesjQ_4589HXGJLnUENm0GXwyn2phUFG8lbfSDRWVfJ5JXFAMeta } from "/opt/buildhome/repo/pages/blog/categories.vue?macro=true";
import { default as profilew5uUefDJpU_45NO0wEWdV1LJI8ay_Fc5lJ5R9m_45E3lcbIMeta } from "/opt/buildhome/repo/pages/settings/profile.vue?macro=true";
import { default as password6X2LEpv4B2NveboRVupd2PLqYv0402zLtZ7GuD4g4OsMeta } from "/opt/buildhome/repo/pages/settings/password.vue?macro=true";
import { default as _91id_93r_45h_45NLEwi67dRTYXsq94Nhd_450cOXGkpQzl9LpQCu5HwMeta } from "/opt/buildhome/repo/pages/blog/post/edit/[id].vue?macro=true";
import { default as _91id_93aaTynLxeOzVztqsFe9s1GioWBWi6E_uzt2dPJpv3DvkMeta } from "/opt/buildhome/repo/pages/blog/post/show/[id].vue?macro=true";
import { default as preferencesn1J_45UUVwBaGXYuE3ZlRFuVLOR2ZBKwVtg7HpfalurS4Meta } from "/opt/buildhome/repo/pages/settings/preferences.vue?macro=true";
export default [
  {
    name: "faqs___br",
    path: "/faqs",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/buildhome/repo/pages/faqs.vue")
  },
  {
    name: "index___br",
    path: "/",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "users___br",
    path: "/users",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/buildhome/repo/pages/users.vue")
  },
  {
    name: "events___br",
    path: "/events",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/buildhome/repo/pages/events.vue")
  },
  {
    name: "sign_in___br",
    path: "/sign_in",
    meta: sign_inFFyEGpE7oqBl66UUOrU5KCGZKsGZ8fc1vpA5h_45LpX_kMeta || {},
    component: () => import("/opt/buildhome/repo/pages/sign_in.vue")
  },
  {
    name: "blog-posts___br",
    path: "/blog/posts",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/buildhome/repo/pages/blog/posts.vue")
  },
  {
    name: "blog-post-new___br",
    path: "/blog/post/new",
    meta: { ...(newo1IuT9FGWtVfRT1zp4vJwDkiQcG_457F7qQtnV7EF4AEUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/blog/post/new.vue")
  },
  {
    name: "blog-categories___br",
    path: "/blog/categories",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/buildhome/repo/pages/blog/categories.vue")
  },
  {
    name: "settings-profile___br",
    path: "/settings/profile",
    meta: { ...(profilew5uUefDJpU_45NO0wEWdV1LJI8ay_Fc5lJ5R9m_45E3lcbIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/settings/profile.vue")
  },
  {
    name: "settings-password___br",
    path: "/settings/password",
    meta: { ...(password6X2LEpv4B2NveboRVupd2PLqYv0402zLtZ7GuD4g4OsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/settings/password.vue")
  },
  {
    name: "blog-post-edit-id___br",
    path: "/blog/post/edit/:id()",
    meta: { ...(_91id_93r_45h_45NLEwi67dRTYXsq94Nhd_450cOXGkpQzl9LpQCu5HwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/blog/post/edit/[id].vue")
  },
  {
    name: "blog-post-show-id___br",
    path: "/blog/post/show/:id()",
    meta: { ...(_91id_93aaTynLxeOzVztqsFe9s1GioWBWi6E_uzt2dPJpv3DvkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/blog/post/show/[id].vue")
  },
  {
    name: "settings-preferences___br",
    path: "/settings/preferences",
    meta: { ...(preferencesn1J_45UUVwBaGXYuE3ZlRFuVLOR2ZBKwVtg7HpfalurS4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/buildhome/repo/pages/settings/preferences.vue")
  }
]